import { connect } from 'react-redux';

import { actionCreators, selectors } from 'dux/instances';
import CRCAMgmt from './CRCAMgmt';

const mapStateToProps = (state) => ({
  getInstanceCertificatesState: selectors.getInstanceCertificatesState(state),
  getPrimaryCertId: selectors.getPrimaryCertId(state),
});

const mapDispatchToProps = {
  getInstanceCertificates: actionCreators.getInstanceCertificates,
  createInstanceCertificate: actionCreators.createInstanceCertificate,
  createInstanceClientCertificate: actionCreators.createInstanceClientCertificate,
  getInstanceCertificateDownload: actionCreators.getInstanceCertificateDownload,
  deleteInstanceCertificate: actionCreators.deleteInstanceCertificate,
};

export default connect(mapStateToProps, mapDispatchToProps)(CRCAMgmt);
